import cAppeared from './components/c-appeared';
import header from './blocks/header';
import form from './blocks/form';
import cFocus from './components/c-focus';
import headerMenu from './blocks/menu';
import newWindowLinks from './components/new-window-links';
import './components/video-controls';
import cSkipMain from './components/c-skip-main';
import navisChat from './components/navis-chat';

// Header
header();
headerMenu();

// Components
cAppeared();
form();
cFocus();
cSkipMain();
navisChat();

document.addEventListener('DOMContentLoaded', async () => {
  newWindowLinks();
  const cOutlineModule = await import('./components/c-outline');
  const footerModule = await import('./blocks/footer');

  const cOutline = cOutlineModule.default;
  const footer = footerModule.default;

  cOutline();
  footer();
});
